import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import TableStore from "@harbor/elements/utils/table/store";
import useColumns from "@harbor/elements/utils/table/hooks/columns";
import AppHOC from "../../../generics/AppHOC";
import NoData from "../../../common/table/NoData";
import { formatRequestPayload } from "../../../utils/query-utils";
import { sortdata } from "../../../utils/common";
import { getTableColumns, setTableData } from "./tableConfig";
import css from "../app360MagneticStyle.less"; 

const [HbrTable] = reactWrapper([
  "hbr-table", 
]);
const tableId = "appflow_table";
const AppFlowTable = props => {
  const { reportView, globalFilter, data, app360 } = props;
  const [loader, setLoader] = useState(true);
  const [, forceUpdate] = useState({}); // Used to trigger re-render from TableStore 
  const tableRef = useRef({ error: null }); // Track fetch error
  const columnsHook = useColumns({
    config: ({ store }) => getTableColumns(tableId, reportView, store),
  }); 
  const tableStore = useMemo(() => {
    return new TableStore({
      query: { page: 0, pageLength: 50 },
      hooks: [columnsHook],
      fetchData: async query => {
        setLoader(true);
        try {
          const rawData = props.data;
          const sortedData = (rawData || []).map(item => ({ ...item }));
          const siteData = reportView
            ? props?.globalFilter?.siteAPIData?.sitesTableData
            : props.globalFilter?.siteAPIData?.sitesTableData?.data || [];
          const requestPayload = formatRequestPayload(
            {},
            props.data,
            tableRef.current?.table
          );
          sortedData.forEach(item => {
            const match = siteData.find(site => site.site_id === item.site_id

            );
            if (match) item.city = match.city;
          });
          const finalData = sortdata(requestPayload, sortedData);
          const tableData = setTableData(finalData);
          query.setSource(tableData);
          query.setCount(tableData.length || 0);
        } catch (error) {
          console.error("Error fetching app flow table:", error);
          tableRef.current.error = error;
          query.setSource([]);
          query.setCount(0);
        } finally {
          setLoader(false);
        }
      }
    });
  }, [data, app360, reportView, globalFilter]);
  useEffect(() => {
    const unsubscribe = tableStore.subscribe(() => forceUpdate({}));
    return () => unsubscribe();
  }, [tableStore]);
  const { source, columns, query } = tableStore.getState();
  const { pageLength } = query;
  return (
    <div className={css["appflow-table"]}
      data-cy="appflowTableView">
      <HbrTable
        id={tableId}
        data-testid={tableId}
        columns={columns}
        source={source}
        className={"appflowTableReport"} 
        serverSide externalSorting readonly resize frameSize={pageLength}
        canFocus={false}
        useClipboard={false}
        headerSlot role="table"
        onHbr-before-sort={event => {
          const { column, order } = event.detail;
          const columnsHook = tableStore.getHook("columns");
          if (order) {
            columnsHook.sort({ order: [[column.id, order]] });
          }
        }}
      >
        <NoData
          count={source.length}
          loader={loader}
          error={tableRef.current.error}
        />
      </HbrTable>
    </div>
  );
};
AppFlowTable.propTypes = {
  data: PropTypes.object.isRequired,
  reportView: PropTypes.bool,
  props: PropTypes.object.isRequired, 
  globalFilter: PropTypes.object.isRequired,
  app360: PropTypes.object.isRequired
};
export default AppHOC(AppFlowTable);
